import React from 'react'
import PropTypes from 'prop-types'
import styles from './TrackList.module.scss'
import Track from '../Track'

export default function TrackList({
  songs = [],
  isCanadianContent = false,
  release,
  metaData,
  showMetadata = false,
  isAllMetaDataTracksExpanded
}) {
  return (
    <div className={styles.list}>
      {songs.map((song, index) => (
        <Track
          key={song?.trackid}
          track={song}
          index={index}
          isCanadianContent={isCanadianContent}
          release={release}
          metaData={metaData}
          showMetadata={showMetadata}
          songs={songs}
          isExpanded={isAllMetaDataTracksExpanded} />
      ))}
    </div>
  )
}

TrackList.propTypes = {
  songs: PropTypes.arrayOf(PropTypes.shape({})),
  isCanadianContent: PropTypes.bool,
  release: PropTypes.shape({}),
  metaData: PropTypes.bool,
  showMetadata: PropTypes.bool,
  isAllMetaDataTracksExpanded: PropTypes.bool
}
